import { render, staticRenderFns } from "./Acceso.vue?vue&type=template&id=082b2aa7"
import script from "./Acceso.vue?vue&type=script&lang=js"
export * from "./Acceso.vue?vue&type=script&lang=js"
import style0 from "./Acceso.vue?vue&type=style&index=0&id=082b2aa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports